import {ComboSearchComponent} from './combo-search.component';

export const COMBO_SEARCH_COMPONENT: any[] = [
    ComboSearchComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/combo-search/index.ts